<template>
  <div>
    <distributor-tile v-if="!distributed"></distributor-tile>
    <first-train-tile v-if="railway"></first-train-tile>
    <first-flight-tile v-else-if="flyway"></first-flight-tile>
    <template v-if="progress">
      <additional-flights-tile v-if="selectedDiv == '20' || pass20"></additional-flights-tile>
      <additional-rides-tile v-if="selectedDiv == '21' || pass21"></additional-rides-tile>
      <alternative-flight-tile v-if="selectedDiv == '31' || pass31"></alternative-flight-tile>
      <airline-notification-tile v-if="selectedDiv == '33' || pass33"></airline-notification-tile>
      <checkin-tile v-if="selectedDiv == '34' || pass34"></checkin-tile>
      <reason-tile v-if="selectedDiv == '35' || pass35"></reason-tile>
      <storno-tile v-if="selectedDiv == '37' || pass37"></storno-tile>
      <result-tile v-if="selectedDiv == '40' || pass40"></result-tile>
      <already-assigned-tile v-if="selectedDiv == '24' || pass24"></already-assigned-tile>
      <!-- <w9-tile v-if="selectedDiv == '41'"></w9-tile> -->
      <personal-data-tile v-if="selectedDiv == '50' || pass50"></personal-data-tile>
      <!-- <coupon-tile v-if="selectedDiv == '51' || pass51"></coupon-tile> -->
      <upload-tile v-if="selectedDiv == '60' || pass60"></upload-tile>
      <final-tile v-if="selectedDiv == '70' || pass70"></final-tile>
      <rejection-tile v-if="selectedDiv == '32'"></rejection-tile>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DistributorTile from "./Tiles/DistributorTile.vue";
import FirstFlightTile from "./Tiles/FirstFlightTile.vue";
import FirstTrainTile from "./Tiles/FirstTrainTile.vue";
import RejectionTile from "./Tiles/RejectionTile.vue";
import AdditionalFlightsTile from "./Tiles/AdditionalFlightsTile.vue";
import AdditionalRidesTile from "./Tiles/AdditionalRidesTile.vue";
import AlreadyAssignedTile from "./Tiles/AlreadyAssignedTile.vue";
import AlternativeFlightTile from "./Tiles/AlternativeFlightTile.vue";
import AirlineNotificationTile from "./Tiles/AirlineNotificationTile.vue";
import CheckinTile from "./Tiles/CheckinTile.vue";
import ReasonTile from "./Tiles/ReasonTile.vue";
import ResultTile from "./Tiles/ResultTile.vue";
import PersonalDataTile from "./Tiles/PersonalDataTile.vue";
import UploadTile from "./Tiles/UploadTile.vue";
import FinalTile from "./Tiles/FinalTile.vue";
// import W9Tile from "./Tiles/W9Tile.vue";
import StornoTile from "./Tiles/StornoTile.vue";
//import CouponTile from "./Tiles/CouponTile.vue";

export default {
  name: "CoreTile",
  components: {
    RejectionTile,
    FirstFlightTile,
    FirstTrainTile,
    AdditionalFlightsTile,
    AdditionalRidesTile,
    AlreadyAssignedTile,
    AlternativeFlightTile,
    AirlineNotificationTile,
    CheckinTile,
    ReasonTile,
    ResultTile,
    PersonalDataTile,
    // CouponTile,
    UploadTile,
    FinalTile,
    // W9Tile,
    StornoTile,
    DistributorTile,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState([
      "selectedDiv",
      "distributed",
      "railway",
      "flyway",
      "progress",
      "pass20",
      "pass21",
      "pass24",
      "pass31",
      "pass33",
      "pass34",
      "pass35",
      "pass36",
      "pass37",
      "pass40",
      "pass50",
      "pass51",
      "pass60",
      "pass70",
      "pass80",
    ]),
  },
  mounted: async function () {
    const queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var slang = "";
    var way = "";
    if (urlParams.has("slang")) {
      slang = urlParams.get("slang");
    } else {
      slang = navigator.language;
    }

    if (urlParams.has("way")) {
      way = urlParams.get("way");
      if (way == "railway") {
        this.setVar({ pos: "railway", val: true });
      } else {
        this.setVar({ pos: "flyway", val: true });
      }
      this.setVar({ pos: "distributed", val: true });
    }

    const plr = await this.getText();
    this.setText({ value: slang, res: plr });
  },
  methods: {
    ...mapActions(["getText", "setText", "setVar"]),
  },
};
</script>
<style>
/* ==========================================================================
   Main options for Ersatz-Pilot CSS
   ========================================================================== */

:root {
  /* COLORS */
  --ep-main-blue: #014c94;
  --ep-dark-blue: #012c54;
  --ep-yellow: #fdd835;
  --ep-red: #db2215;
  --ep-grey: #808080;
  --ep-light-grey: #e0e0e0;
  --ep-white: #ffffff;
  --ep-green: #00b67a;
}

/* ==========================================================================
   Font, headings and paragraph mods
   ========================================================================== */

/* Font mods */

#app p {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 1.5rem;
  margin: 0.8em 0 1.6em;
  color: #404040;
}

#app .theme--light.v-card .v-card__subtitle,
.theme--light.v-card>.v-card__text {
  color: #404040;
}

#app .v-application .primary--text {
  color: var(--ep-main-blue) !important;
  caret-color: var(--ep-main-blue) !important;
}

#app h2.ep-rechner-h2 {
  font-size: 1.5rem;
  line-height: 1.813rem;
  text-align: center;
  margin: 0;
  padding: 0rem;
}

#app h3.ep-rechner-h3 {
  font-size: 1.3rem;
  text-align: center;
}

#app p.progress-text {
  margin-bottom: 5px !important;
}

#app h2.v-card--head--title {
  width: 100%;
  background-color: var(--ep-main-blue);
  color: #fff !important;
  text-align: center;
  padding: 2rem;
  margin: 0;
  display: -webkit-box;
  display: -ms-flexbox;

  vertical-align: middle;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-line-pack: baseline;
  align-content: baseline;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

#app h3.hghlght {
  text-align: center;
  font-size: 20px;
  background-color: var(--ep-dark-blue);
  color: #ffffff !important;
  padding: 0.75rem;
  border-bottom: 10px solid #014c94;
  margin: 0;
}

#app h3.offer {
  text-align: center;
  font-size: 20px;
  font-weight: bolder;
  background-color: var(--ep-green);
  color: #ffffff !important;
  padding: 0.75rem;
  border-bottom: 10px solid var(--ep-main-blue);
  margin: 0;
}

#app .primary-text {
  color: var(--ep-dark-blue);
}

/* ==========================================================================
    INPUT FIELDS
   ========================================================================== */
.v-file-input .v-input__prepend-outer {
  margin-left: auto !important;
  margin-right: auto !important;
}

.v-file-input .v-icon.v-icon {
  font-size: 50px !important;
  color: #000000 !important;
}

#app input {
  background-color: var(--ep-light-grey);
  color: rgba(0, 0, 0);
}

.uchip button {
  color: #012c54 !important;
}

#app input:disabled {
  color: rgb(0, 0, 0, 0.5);
}

/* Remove border from input fields */
.v-text-field>.v-input__control>.v-input__slot:before {
  border: none;
}

.v-input__append-inner {
  background-color: var(--ep-dark-blue);
  margin: 0 !important;
  height: 100%;
  max-height: 2rem;
  height: 2rem;
}

/* Remove border from input fields */
.v-select__selections {
  background-color: var(--ep-light-grey);
  padding-left: 0.5rem;
  color: #000000;
}

/* Input labels
   ========================================================================== */

.theme--light.v-label {
  color: #000000;
  font-weight: 400 !important;
}

.v-text-field .v-label--active {
  max-width: 133%;
  -webkit-transform: translateY(-24px) scale(0.75);
  transform: translateY(-24px) scale(0.75);
}

.v-text-field input {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  line-height: 20px;
  padding: 8px;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.v-text-field .v-label {
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  top: 6px;
  white-space: nowrap;
  pointer-events: none;
  /* Apply padding to labels */
  padding-left: 8px;
  /* IMPORTANT: Display label in front of background */
  z-index: 3;
}

/* Form validation
   ========================================================================== 

.v-application .error--text {
  color: var(--ep-red) !important;
  caret-color: var(--ep-red) !important;
}
   ==========================================================================
   ICONS
   ========================================================================== */

/* Increase size of icon */
.v-icon.v-icon {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-font-feature-settings: "liga";
  font-feature-settings: "liga";
  font-size: 30px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  letter-spacing: normal;
  line-height: 1;
  position: relative;
  text-indent: 0;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.tooltipbox .v-icon {
  z-index: 200;
}

/* Color for disabled icons */
.theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(189, 189, 189) !important;
}

.theme--light.v-icon {
  color: var(--ep-light-grey);
}

/* Color of dropdown selectors */
button.v-icon.notranslate.v-icon--link.mdi.mdi-close.theme--light,
i.v-icon.notranslate.mdi.mdi-menu-down.theme--light {
  color: #ffffff;
}

i.v-icon.notranslate.v-icon--disabled.material-icons.theme--light {
  color: var(--ep-light-grey) !important;
}

/* Date picker buttons */
#app .v-btn--icon[aria-label="Previous month"],
#app .v-btn--icon[aria-label="Next month"] {
  color: var(--ep-main-blue) !important;
}

/* ==========================================================================
   Spacing and Layout
   ========================================================================== */

.v-card--head {
  margin: 0;
  padding: 0;
}

.ep-rechner-box {
  margin-bottom: 5rem;
}

.v-card__text>.text--primary>.row {
  padding: 1.25rem;
}

.row.row-btn {
  display: flex;
  align-content: center;
  justify-content: space-around;
}

/* ==========================================================================
   Custom Styling of V-Components
   ========================================================================== */

/* Overlap effect for v-card-actions section */
.v-card__actions {
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  width: 90%;
  margin-top: calc(2.813rem / (-2));
  position: absolute;
  margin-left: 5%;
  display: flex;
  height: 2.813rem;
  border-radius: 0.25rem !important;
}

/* Special class for division effect in v card */
.row.divider-topline {
  text-align: center;
  display: flex;
  justify-content: center;
  padding: 1.24rem;
  margin-top: 1.24rem;
  margin-bottom: 1.24rem;
  border-top: 1px solid var(--ep-light-grey);
}

.row.divider-topline-res {
  text-align: center;
  display: flex;
  justify-content: center;
  padding-bottom: 1.24rem;
  margin-top: 1.24rem;
  margin-bottom: 1.24rem;
  border-top: 1px solid var(--ep-light-grey);
}

.row.tooltipbox {
  height: 0px !important;
  text-align: center;
  display: flex;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.row.tooltipbox-fflight-1 {
  height: 35px !important;
}

.row.tooltipbox-storno-1 {
  text-align: center;
  display: flex;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.row.tooltipbox-storno-2 {
  text-align: center;
  display: flex;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.row.tooltipbox-storno-3 {
  text-align: center;
  display: flex;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.row.tooltipbox-storno-4 {
  text-align: center;
  display: flex;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.row.tooltipbox-final {
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

@media (max-width: 600px) {
  .row.tooltipbox-storno-1 button {
    left: 0px;
    top: -25px;
  }

  .row.tooltipbox-storno-1 .v-tooltip__content {
    left: 0px !important;
    top: 25px !important;
  }

  .row.tooltipbox-storno-2 button {
    left: 0px;
    top: -25px;
  }

  .row.tooltipbox-storno-2 .v-tooltip__content {
    left: 0px !important;
    top: 25px !important;
  }

  .row.tooltipbox-storno-3 button {
    left: 0px;
    top: -35px;
  }

  .row.tooltipbox-storno-3 .v-tooltip__content {
    left: 0px !important;
    top: 30px !important;
  }

  .row.tooltipbox-storno-4 button {
    left: 0px;
    top: 0px;
  }

  .row.tooltipbox-storno-4 .v-tooltip__content {
    left: 0px !important;
    top: 40px !important;
  }
}

@media (min-width: 601px) {
  .row.tooltipbox {
    height: 0px !important;
  }

  .row.tooltipbox-storno-1 {
    height: 0px !important;
    height: 30px !important;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }

  .row.tooltipbox-storno-2 {
    height: 0px !important;
    height: 30px !important;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }

  .row.tooltipbox-storno-3 {
    height: 0px !important;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }

  .row.tooltipbox-storno-4 {
    height: 0px !important;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }

  .row.tooltipbox-storno-1 button {
    left: -30px;
    top: -75px;
  }

  .row.tooltipbox-storno-1 .v-tooltip__content {
    left: -30px !important;
    top: -35px !important;
  }

  .row.tooltipbox-storno-2 button {
    left: -30px;
    top: -78px;
  }

  .row.tooltipbox-storno-2 .v-tooltip__content {
    left: -30px !important;
    top: -25px !important;
  }

  .row.tooltipbox-storno-3 button {
    left: -20px;
    top: -135px;
  }

  .row.tooltipbox-storno-3 .v-tooltip__content {
    left: -30px !important;
    top: -90px !important;
  }

  .row.tooltipbox-storno-4 button {
    left: -20px;
    top: -90px;
  }

  .row.tooltipbox-storno-4 .v-tooltip__content {
    left: -30px !important;
    top: -45px !important;
  }

  .tooltipbox-upload {
    height: 0px !important;
  }
}

.tooltipbox-upload {
  text-align: center;
  display: flex;
  justify-content: center;
}

.tooltipbox-upload button {
  margin-top: 17px !important;
}

.divider-bottomline {
  border-bottom: 1px solid var(--ep-light-grey);
}

.row.tooltipbox button {
  top: -60px;
}

.row.tooltipbox-upload button {
  top: -35px !important;
}

.row.tooltipbox-result button {
  top: -90px !important;
}

.row.tooltipbox-zubi button {
  top: -45px;
}

/* ==========================================================================
   Images
   ========================================================================== */

.success-msg-img {
  height: 150px;
  width: 150px;
  margin: auto;
}

/* ==========================================================================
   Buttons
   ========================================================================== */

/* Button for next calc step */
button.btn-ep-next-step {
  background-color: var(--ep-main-blue) !important;
  padding: 1.25rem;
  color: white !important;
  font-size: 1rem;
}

/* Button for prev calc step */
button.btn-ep-back-to {
  background-color: var(--ep-dark-blue) !important;
  padding: 1.25rem;
  color: white !important;
  font-size: 1rem;
}

button.mr-4.v-btn.v-btn--block.v-btn--contained.theme--light.v-size--default.success {
  background-color: var(--ep-main-blue);
  margin-top: 1rem;
  height: 2.813rem;
  border-radius: 0.25rem !important;
}

/* Button used for legal note*/
button.v-btn.v-btn--flat.v-btn--text.theme--light.v-size--default.error--text {
  background-color: var(--ep-yellow);
  color: white !important;
  margin-bottom: 1rem;
  overflow-wrap: break-word;
  white-space: normal;
}

.row.row-btn>.col>button {
  font-size: 1.15rem;
  background-color: var(--ep-dark-blue) !important;
  margin-top: 1rem;
  height: 2.813rem;
  border-radius: 0.25rem !important;
}

.row.row-btn>.col>button.light {
  font-size: 1.15rem;
  background-color: var(--ep-main-blue) !important;
  margin-top: 1rem;
  height: 2.813rem;
  border-radius: 0.25rem !important;
}

@media (max-width: 335px) {
  .row.tooltipbox-result button {
    top: -170px !important;
  }
}

@media (min-width: 336px) and (max-width: 445px) {
  .row.tooltipbox-result button {
    top: -145px !important;
  }
}

@media (min-width: 446px) and (max-width: 959px) {
  .row.tooltipbox-result button {
    top: -117px !important;
  }
}

/* Text color in V-actions component */
@media (max-width: 767px) {
  .infoHover>.v-btn>.v-btn__content {
    width: 100%;
    overflow-wrap: break-word !important;
    /*width: min-content;*/
    line-height: 1.25rem;
    /* Ersatz-Pilot button font weight */
    font-weight: 600;
    /* break behavior */
    white-space: pre-wrap;
    display: block !important;
  }

  .infoHover>.v-btn {
    min-height: 50px !important;
  }
}

@media (max-width: 385px) {
  .infoHover>.v-btn {
    min-height: 85px !important;
  }
}

/* ==========================================================================
   Collapsable text â€” shown on hover
   ========================================================================== */

div.infoHover {
  white-space: normal;
}

/* Hover collapse text */
.transition-fast-in-fast-out.text-center {
  font-size: 1rem;
  text-align: left !important;
  line-height: 1.5rem;
}

/* ==========================================================================
   Media queries
   ========================================================================== */

@media (max-width: 1264px) {

  /* no paragraph margin on smaller screens */
  #app p {
    margin: 0;
  }

  #app h2.ep-rechner-h2 {
    padding: 0rem;
  }

  #app h2.v-card--head--title {
    font-size: 1.5rem;
    line-height: 2.25rem;
  }
}

@media (min-width: 1264px) {

  /* Increase font size for card buttons on larger screens */
  .v-card__actions>.v-btn>span.v-btn__content {
    font-size: 1.15rem;
    color: white;
  }
}

@media (min-width: 769px) {
  .ep-provider-img {
    margin: auto;
    width: auto;
    height: 240px;
  }
}

.ep-provider-img {
  margin: auto;
  max-width: 100%;
}

.anspr {
  font-size: 2rem;
  font-weight: bolder;
  color: #024c94;
}

#app .v-application .noshadow .v-dialog__content {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.ansprtext {
  font-size: 1.1rem;
}
</style>
